import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { couleurs } from "../theme/tokens";

/**
 * Écran d'attente pendant le chargement différé d'un module (App.tsx).
 *
 * Volontairement sobre et centré : il n'apparaît qu'une fraction de
 * seconde, à la première ouverture d'un module d'administration. Un
 * squelette plus élaboré ferait surtout clignoter l'écran.
 */
export default function ChargementEcran() {
    return (
        <Box
            sx={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <CircularProgress sx={{ color: couleurs.BleuClair }} />
        </Box>
    );
}
